// Module
var code = "<ng-form> <kform-builder-option property=\"validate.card\"></kform-builder-option> </ng-form> ";
// Exports
export default code;